/**
 * Product Tabs - Laoli Theme
 * Handles product information tabs switching (details/care)
 */

function initPdpTabs() {
  const detailsButton = document.querySelectorAll('.js-details-button');
  const detailsWrapper = document.querySelectorAll('.js-details-wrapper');
  const careButton = document.querySelectorAll('.js-care-button');
  const careWrapper = document.querySelectorAll('.js-care-wrapper');

  if (!detailsButton.length || !careButton.length) {
    return;
  }

  // Details/Care tabs functionality
  detailsButton.forEach((button, index) => {
    button.addEventListener('click', function() {
      detailsButton.forEach(btn => btn.classList.add('controls-item-active'));
      careButton.forEach(btn => btn.classList.remove('controls-item-active'));
      detailsWrapper.forEach(wrapper => wrapper.style.display = 'block');
      careWrapper.forEach(wrapper => wrapper.style.display = 'none');
    });
  });

  careButton.forEach((button, index) => {
    button.addEventListener('click', function() {
      detailsButton.forEach(btn => btn.classList.remove('controls-item-active'));
      careButton.forEach(btn => btn.classList.add('controls-item-active'));
      detailsWrapper.forEach(wrapper => wrapper.style.display = 'none');
      careWrapper.forEach(wrapper => wrapper.style.display = 'block');
    });
  });
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initPdpTabs };
}
